/**
 * Abstract class for every action card.
 * Every class must define :
 *   - static typeId
 *   - static name
 *   - static colorHex
 *   - static countInDeck
 *   - isValidOn(slotIndex, gameState)
 *   - resolve(slotIndex, gameState)
 */
export class ActionCard {
    constructor(uid) {
        this.uid = uid;
        this.typeId = this.constructor.typeId;
        this.name = this.constructor.cardName;
        this.colorHex = this.constructor.colorHex;
        this.countInDeck = this.constructor.countInDeck;
        this.description = this.constructor.description;
    }

    /**
     * Return true if the selected action is valid
     * @param {number} slotIndex
     * @param {GameState} gameState
     * @returns {boolean}
     */
    isValidOn(slotIndex, gameState) {
        throw new Error(`${this.constructor.name} doit implémenter isValidOn()`);
    }

    /**
     * Execute game mutation
     * @param {number} slotIndex
     * @param {GameState} gameState
     * @returns {void}
     */
    resolve(slotIndex, gameState) {
        throw new Error(`${this.constructor.name} doit implémenter resolve()`);
    }
}
